import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./AllProductCss/AllProduct.css";
import AdminLayout from "../AdminLayout";
import TableData from "./TableData";
import useProductHook from "./hooks/useProductHook";

const AllCategory = () => {
  const {
    categoryHeaders,
    categoryData,
    totalCateogryData,
    setTotalCategoryData,
    fetchAllCategories,
  } = useProductHook();

  useEffect(() => {
    fetchAllCategories();
  }, []);

  return (
    <div>
      <AdminLayout>
        <TableData
          tableHeader="Total Category"
          dataArr={totalCateogryData}
          tableHeaders={categoryHeaders}
          tableType="category"
        />
      </AdminLayout>
    </div>
  );
};

export default AllCategory;
